// step8.js - Other Operational Issues (Enhanced with photo upload support)
import React from 'react';
import ModernDataTable from '../ui/ModernDataTable';

const Step8 = ({ 
  otherOperationalItems, 
  setOtherOperationalItems, 
  defaultDateTime,
  enablePhotoUpload,
  referenceNo,
  sectionName,
  dataTableRef
}) => {
  const operationalFields = [
    {
      name: 'timeRaised',
      type: 'datetime',
      label: 'Time Raised',
      header: 'Time Raised',
      required: true,
      validationMessage: 'Please enter when the operational issue was first identified',
      hint: 'Record the exact time when this operational issue was discovered or first reported.'
    },
    {
      name: 'operationalCategory',
      type: 'dropdown',
      label: 'Operational Issue Category',
      header: 'Category',
      placeholder: 'Select the type of operational issue',
      options: [
        { value: 'Communication Issue', label: 'Communication Issue' },
        { value: 'Crowd Management', label: 'Crowd Management' },
        { value: 'Vendor/Supplier Problem', label: 'Vendor/Supplier Problem' },
        { value: 'Technology/Systems Failure', label: 'Technology/Systems Failure' },
        { value: 'Logistics/Coordination Issue', label: 'Logistics/Coordination Issue' },
        { value: 'Security Operations', label: 'Security Operations' },
        { value: 'Emergency Procedures', label: 'Emergency Procedures' },
        { value: 'Staff Coordination', label: 'Staff Coordination' },
        { value: 'Resource/Equipment Shortage', label: 'Resource/Equipment Shortage' },
        { value: 'Other Operational Issue', label: 'Other Operational Issue' }
      ],
      required: true,
      validationMessage: 'Please select the operational issue category',
      hint: 'Choose the category that best describes the type of operational problem encountered.'
    },
    {
      name: 'description',
      type: 'textarea',
      label: 'Description of Issue',
      header: 'Description',
      placeholder: 'Describe the operational issue that occurred...',
      required: true,
      validationMessage: 'Please provide a detailed description of the operational issue',
      hint: (
        <div>
          <p style={{ margin: '0 0 0.5rem 0', fontWeight: '500' }}>Describe the operational issue including:</p>
          <ul style={{ margin: 0, paddingLeft: '1rem' }}>
            <li>Specific nature of the operational problem</li>
            <li>Impact on event operations or attendees</li>
            <li>Root cause or contributing factors</li>
            <li>Departments or teams affected</li>
            <li>Urgency and priority level</li>
          </ul>
        </div>
      )
    },
    {
      name: 'impactLevel',
      type: 'dropdown',
      label: 'Impact Level',
      header: 'Impact Level',
      placeholder: 'Assess the impact level of this operational issue',
      options: [
        { value: 'Minimal - Little to no operational impact', label: 'Minimal - Little to no operational impact' },
        { value: 'Low - Minor operational disruption', label: 'Low - Minor operational disruption' },
        { value: 'Medium - Moderate operational impact', label: 'Medium - Moderate operational impact' },
        { value: 'High - Significant operational disruption', label: 'High - Significant operational disruption' },
        { value: 'Critical - Major operational failure', label: 'Critical - Major operational failure' }
      ],
      required: true,
      validationMessage: 'Please assess the impact level of this operational issue',
      hint: 'Evaluate the severity of impact this issue had on overall event operations and attendee experience.'
    },
    {
      name: 'actionsTaken',
      type: 'textarea',
      label: 'Actions Taken',
      header: 'Actions Taken',
      placeholder: 'Describe actions taken to address the operational issue...',
      validationMessage: 'Please describe the actions taken to resolve the operational issue',
      hint: (
        <div>
          <p style={{ margin: '0 0 0.5rem 0', fontWeight: '500' }}>Document operational response including:</p>
          <ul style={{ margin: 0, paddingLeft: '1rem' }}>
            <li>Immediate corrective actions taken</li>
            <li>Teams or departments involved in resolution</li>
            <li>Resources deployed or reallocated</li>
            <li>Communication to stakeholders</li>
            <li>Escalation procedures followed</li>
            <li>Preventive measures implemented</li>
          </ul>
        </div>
      )
    }
  ];

  return (
    <ModernDataTable
      suppressTitle={true}
      data={otherOperationalItems}
      setData={setOtherOperationalItems}
      fields={operationalFields}
      addButtonText="Add Other Operational Issue"
      emptyMessage="No other operational issues added yet."
      truncateLines={2}
      defaultDateTime={defaultDateTime}
      enablePhotoUpload={enablePhotoUpload}
      referenceNo={referenceNo}
      sectionName={sectionName}
      ref={dataTableRef}
    />
  );
};

export default Step8;